<template>
  <div />
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
defineOptions({ layout: AppLayout })
defineProps({ driver: Object, payouts: Array })
</script>
